import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IWorker } from "./workers.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class WorkersService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getWorkers(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_WORKERS)}${queryParams}`);
  }

  getWorker(worker: IWorker | string): Observable<any> {
    let id = (typeof worker == 'string') ? worker : worker._id;
    return this._http.get(`${apiURL(EnvConfig.API_WORKERS)}/${id}`);
  }

  createWorker(worker: IWorker): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_WORKERS)}`, worker);
  }

  updateWorker(worker: IWorker): Observable<any> {
    let id = worker._id;
    delete worker._id;
    return this._http.patch(`${apiURL(EnvConfig.API_WORKERS)}/${id}`, worker);
  }

  deleteWorker(worker: IWorker | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof worker == 'string') ? worker : worker._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_WORKERS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_WORKERS)}/${id}/delete`);
  }

  restoreWorker(worker: IWorker | string): Observable<void> {
    let id = (typeof worker == 'string') ? worker : worker._id;
    return this._http.post(`${apiURL(EnvConfig.API_WORKERS)}/${id}/restore`, null);
  }
}